import { createRootRoute, createRouter, Outlet, RouterProvider } from '@tanstack/react-router';
import { homePageRoute } from 'pages/HomePage';
import { invitationAcceptPageRoute, invitationRejectPageRoute } from 'pages/InvitationPage';
import { NotFoundPage } from 'pages/NotFoundPage';
import { privacyPolicyRoute } from 'pages/PrivacyPolicy';
import { registerNowPageRoute } from 'pages/RegisterNow';
import { requestDemoPageRoute } from 'pages/RequestDemoPage';
import { termsOfUseRoute } from 'pages/TermsOfUse';

const Root = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export const rootRoute = createRootRoute({
  component: Root,
  notFoundComponent: () => <NotFoundPage />,
});

const routeTree = rootRoute.addChildren([
  homePageRoute,
  requestDemoPageRoute,
  registerNowPageRoute,
  termsOfUseRoute,
  privacyPolicyRoute,
  invitationAcceptPageRoute,
  invitationRejectPageRoute,
]);

const router = createRouter({ routeTree });

export const Router = () => <RouterProvider router={router} />;
